import { useCallback, useEffect, useState } from 'react';
import { debounce, DEBOUNCE_DELAY } from 'utils';
import { Input } from './shadcn/input';

interface Props {
  value?: string;
  onChange: (s?: string) => void;
  placeholder?: string;
  className?: string;
}

export default function SearchBar({ placeholder, value, onChange, className }: Props) {
  const [search, setSearch] = useState<string>(value || '');

  useEffect(() => {
    setSearch(value || '');
  }, [value]);

  const debouncedSearch = useCallback(
    debounce((v: string) => {
      onChange(v);
    }, DEBOUNCE_DELAY),
    [onChange],
  );

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Escape') {
      onChange('');
    }
  };

  return (
    <Input
      className={className}
      onKeyDown={handleKeyDown}
      value={search}
      onChange={(e) => {
        setSearch(e.target.value);
        debouncedSearch(e.target.value);
      }}
      type="search"
      placeholder={placeholder}
    />
  );
}
